import AsyncJobsPage from './async-jobs-page';

export default AsyncJobsPage;


// WEBPACK FOOTER //
// ./src/features/organization/pages/async-jobs/index.js